"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CIRCLE_STATUS = void 0;
const colors_1 = require("../styles/colors");
exports.CIRCLE_STATUS = {
    draft: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$grey40,
        height: '24px',
        width: '24px',
    },
    ongoing: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$primaryBrand,
        height: '24px',
        width: '24px',
    },
    pendingAction: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$orange,
        height: '24px',
        width: '24px',
    },
    alternativeStatus: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$yellow,
        height: '24px',
        width: '24px',
    },
    processed: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$darkGreen,
        height: '24px',
        width: '24px',
    },
    deleted: {
        border: `1px solid ${colors_1.$primaryBlack}`,
        borderRadius: '50%',
        color: colors_1.$darkRed,
        height: '24px',
        width: '24px',
    },
};
